import { HttpErrorResponse } from '@angular/common/http';

export class BindingContext {
	static _nextInstanceID = 0;
	_instanceID = ++BindingContext._nextInstanceID;
	isInitialized = false;
	isBusy = false;
	hasData = false;
	hasError = false;
	_errorMessage: string;
	errorResponse: HttpErrorResponse;
	public alertType: BindingContext.alertType = BindingContext.alertType.none;
	hasAlert = false;
	alertMessage: string;

	get showError(): boolean {
		return this.hasError;
	}
	get showBusy(): boolean {
		return this.isBusy;
	}
	public get showData(): boolean {
		let result = false;
		if (this.isInitialized === true) {
			result = this.hasData && !this.hasError;
		}
		return result;
	}
	get showNoResults(): boolean {
		let result = false;
		if (this.isInitialized === true) {
			result = !this.hasError && !this.hasData && !this.isBusy;
		}
		return result;
	}
	get errorMessage(): string {
		return this._errorMessage;
	}
	/**
	 * Sets an error in the context and displays it as a red alert
	 * @param error The error from the request
	 * @param hasData Optional boolean for whether data was returned
	 */
	setError(error: HttpErrorResponse, hasData: boolean = true) {
		this.isInitialized = true;
		this.hasData = hasData;
		this.isBusy = false;
		this.errorResponse = error;
		if (error) {
			this.hasError = true;
			if (error.statusText) {
				this._errorMessage = error.statusText;
			}
		} else {
			this._errorMessage = null;
			this.hasError = false;
		}
	}
	/**
	 * Shows the passed in alert via the component
	 * @param alertType Type of alert message to display
	 * @param message The message to display within the type
	 */
	showAlert(alertType: BindingContext.alertType, message: string, isError: boolean = false) {
		if (isError) {
			this.hasError = true;
			this._errorMessage = message;
			this.isInitialized = true;
			this.isBusy = false;
		} else {
			this.hasAlert = true;
			this.alertMessage = message;
			this.alertType = alertType;
		}
	}
	/**
	 * Hides the current alert
	 */
	hideAlert() {
		this.hasAlert = false;
		this.alertMessage = null;
		this.alertType = BindingContext.alertType.none;
	}
	/**
	 * Begins a get call,
	 * Sets context to busy and error free without data
	 */
	beginGet() {
		this.isInitialized = true;
		this.isBusy = true;
		this.hasData = false;
		this.hasError = false;
	}
	/**
	 * Ends the binding context get call, 
	 * resets the loading spinner and marks the request error-free with data
	 * @param hasData Boolean whether or not data was returned
	 */
	endGet(hasData: boolean = true) {
		this.isInitialized = true;
		this.isBusy = false;
		this.hasData = hasData;
		this.hasError = false;
	}
	/**
	 * Clears out the context
	 */
	clear() {
		this.isInitialized = false;
		this.isBusy = false;
		this.hasData = false;
		this.hasError = false;
	}

	constructor() { }
}
export namespace BindingContext {
	export enum alertType {
		none = 0,
		primary,
		secondary,
		success,
		danger,
		warning,
		info,
		light,
		dark
	}
}
